import { Role } from '@zorro/clients';
import {
  isAccountSupervisor,
  isAgencyAdminRole,
  isAgentRole,
  isAgentWithoutSupervisor,
  isEmployeeOnlyRole,
  isEmployerAdminRole,
  isManagement,
  isOmnipotentAdmin,
  isZorroOperationsRole,
} from '@zorro/common-utils';

import { isNonZorroEnrollmentAgent } from '../agency';
import { useImpersonation } from './useImpersonation';

export function useRoles() {
  const { user, authUser, isLoading } = useImpersonation();

  const roles: Role[] = user?.roles.map(({ id }) => id) ?? [];

  return {
    userRoles: roles,
    // The signed-in actor's roles; under impersonation `userRoles` are the
    // employee's.
    authUserRoles: authUser?.roles.map(({ id }) => id) ?? [],
    isEmployeeOnlyRole: isEmployeeOnlyRole(roles),
    isZorroOperations: isZorroOperationsRole(roles),
    isAgent: isAgentRole(roles),
    isAgencyAdmin: isAgencyAdminRole(roles),
    isAgentWithoutSupervisor: isAgentWithoutSupervisor(roles),
    isAccountSupervisor: isAccountSupervisor(roles),
    isEmployerAdmin: isEmployerAdminRole(roles),
    isManagement: isManagement(roles),
    isOmnipotentAdmin: isOmnipotentAdmin(roles),
    isLoading,
    isNonZorroEnrollmentAgent:
      isAgentRole(roles) && isNonZorroEnrollmentAgent(user),
  };
}
